import { FC } from 'react';
import { KTIcon } from '../../../../../../_metronic/helpers';

interface Props {
	handleModalClose: () => void;
}

const SubscriptionModalHeader: FC<Props> = ({ handleModalClose }) => {
	return (
		<div className='modal-header'>
			{/* begin::Modal title */}
			<h2 className='fw-bolder'>Настройка Категории</h2>
			{/* end::Modal title */}

			{/* begin::Close */}
			<div
				className='btn btn-icon btn-sm btn-primary btn-active-icon-light'
				onClick={handleModalClose}
				data-kt-users-modal-action='close'
				style={{ cursor: 'pointer' }}
			>
				<KTIcon iconName='cross' className='fs-1' />
			</div>
			{/* end::Close */}
		</div>
	);
};

export { SubscriptionModalHeader };
